import config from "config/config";
export async function saveUserTransaction(payload) {
  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
    body: JSON.stringify(payload),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/Transaction",
    options
  );
  if (response.ok) {
    return;
  } else {
    throw response;
  }
}
